import React from 'react';
import { Truck, Clock, MapPin, Package } from 'lucide-react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useApp } from '../../context/AppContext';

const VerzendingPage = () => {
  const { t } = useApp();
  
  return (
    <div className="min-h-screen bg-[#050505] flex flex-col">
      <Navbar />
      
      <main className="flex-1 container mx-auto px-4 md:px-8 py-12">
        <h1 className="font-heading text-3xl md:text-4xl text-white mb-2">{t('shipping_title')}</h1>
        <p className="text-[#A8A29E] mb-8">{t('shipping_subtitle')}</p>

        <div className="max-w-4xl space-y-8">
          {/* Standard Shipping */}
          <div className="glass rounded-xl p-6">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-[#D4AF37]/10 rounded-lg">
                <Truck size={24} className="text-[#D4AF37]" />
              </div>
              <div>
                <h2 className="font-heading text-xl text-white mb-2">{t('standard_shipping')}</h2>
                <p className="text-[#A8A29E] mb-4">
                  {t('standard_shipping_desc')}
                </p>
                <ul className="space-y-2 text-[#A8A29E]">
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#D4AF37]"></span>
                    {t('free_shipping_from_50')}
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#D4AF37]"></span>
                    {t('shipping_under_50')}
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#D4AF37]"></span>
                    {t('track_trace_email')}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Express Delivery */}
          <div className="glass rounded-xl p-6 border border-[#D4AF37]/30">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-[#D4AF37]/20 rounded-lg">
                <Clock size={24} className="text-[#D4AF37]" />
              </div>
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <h2 className="font-heading text-xl text-white">{t('direct_delivery')}</h2>
                  <span className="bg-[#D4AF37] text-black text-xs px-2 py-0.5 rounded font-bold">PREMIUM</span>
                </div>
                <p className="text-[#A8A29E] mb-4">
                  {t('direct_delivery_desc')}
                </p>
                <ul className="space-y-2 text-[#A8A29E]">
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#D4AF37]"></span>
                    {t('delivery_within_3h')}
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#D4AF37]"></span>
                    {t('available_7_days')}
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#D4AF37]"></span>
                    {t('whole_netherlands')}
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#D4AF37]"></span>
                    {t('surcharge_25')}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Delivery Areas */}
          <div className="glass rounded-xl p-6">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-[#D4AF37]/10 rounded-lg">
                <MapPin size={24} className="text-[#D4AF37]" />
              </div>
              <div>
                <h2 className="font-heading text-xl text-white mb-2">{t('delivery_area')}</h2>
                <p className="text-[#A8A29E] mb-4">
                  {t('delivery_area_desc')}
                </p>
              </div>
            </div>
          </div>

          {/* Packaging */}
          <div className="glass rounded-xl p-6">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-[#D4AF37]/10 rounded-lg">
                <Package size={24} className="text-[#D4AF37]" />
              </div>
              <div>
                <h2 className="font-heading text-xl text-white mb-2">{t('packaging')}</h2>
                <p className="text-[#A8A29E]">
                  {t('packaging_desc')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default VerzendingPage;
